import {
  Badge,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@virtual-care/shadcn';

interface AccountStatusBadgeProps {
  status: string;
  suspensionReason?: string | null;
}

export function AccountStatusBadge({
  status,
  suspensionReason,
}: AccountStatusBadgeProps) {
  const badge = (() => {
    switch (status) {
      case 'ACTIVE':
        return (
          <Badge className="bg-green-100 text-green-800 hover:bg-green-100">
            Active
          </Badge>
        );
      case 'REGISTERED':
        return (
          <Badge className="bg-yellow-100 text-yellow-800 hover:bg-yellow-100">
            Registered
          </Badge>
        );
      case 'SUSPENDED':
        return (
          <Badge className="bg-amber-100 text-amber-800 hover:bg-amber-100">
            Suspended
          </Badge>
        );
      case 'REJECTED':
        return (
          <Badge className="bg-red-100 text-red-800 hover:bg-red-100">
            Rejected
          </Badge>
        );
      default:
        return <Badge variant="secondary">{status}</Badge>;
    }
  })();

  if (status === 'SUSPENDED' && suspensionReason) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>{badge}</TooltipTrigger>
        <TooltipContent className="max-w-xs">
          <p className="font-medium">Suspension Reason:</p>
          <p>{suspensionReason}</p>
        </TooltipContent>
      </Tooltip>
    );
  }

  return badge;
}
